/* eslint-disable react/prefer-stateless-function */
/* eslint react/no-multi-comp: 0, react/prop-types: 0 */
import React from 'react';
import { PrismCode } from 'react-prism';
import Helmet from 'react-helmet';
import BadgeExample from '../examples/Badge';
import BadgeButtonExample from '../examples/BadgeButton';
import BadgePillsExample from '../examples/BadgePills';
import BadgeVariationsExample from '../examples/BadgeVariations';
import BadgeLinksExample from '../examples/BadgeLinks';
import BadgeOutlineExample from '../examples/BadgeOutline';
import BadgeWithIconsExample from '../examples/BadgeWithIcons';
const BadgeExampleSource = require('!!raw-loader!../examples/Badge');
const BadgeButtonExampleSource = require('!!raw-loader!../examples/BadgeButton');
const BadgePillsExampleSource = require('!!raw-loader!../examples/BadgePills');
const BadgeVariationsExampleSource = require('!!raw-loader!../examples/BadgeVariations');
const BadgeLinksExampleSource = require('!!raw-loader!../examples/BadgeLinks');
const BadgeOutlineExampleSource = require('!!raw-loader!../examples/BadgeOutline');
const BadgeWithIconsExampleSource = require('!!raw-loader!../examples/BadgeWithIcons');
export default class BadgesPage extends React.Component {
    render() {
        return (<div>
                <Helmet title="Badges"/>
                <h3>Badges</h3>
                <hr />
                <p>Scale to parent</p>
                <div className="docs-example">
                    <BadgeExample />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{BadgeExampleSource}</PrismCode>
                </pre>
                <p>Badges can be used as part of links or buttons to provide a counter.</p>
                <div className="docs-example">
                    <BadgeButtonExample />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{BadgeButtonExampleSource}</PrismCode>
                </pre>
                <h3>Contextual variations</h3>
                <div className="docs-example">
                    <BadgeVariationsExample />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{BadgeVariationsExampleSource}</PrismCode>
                </pre>
                <h3>Badge Outline</h3>
                <div className="docs-example">
                    <BadgeOutlineExample />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{BadgeOutlineExampleSource}</PrismCode>
                </pre>
                <h3>Pills</h3>
                <div className="docs-example">
                    <BadgePillsExample />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{BadgePillsExampleSource}</PrismCode>
                </pre>
                <h3>Links</h3>
                <p>
                    Adding the <code>href</code> prop (without specifying a <code>tag</code> prop) will default the
                    badge to a link.
                </p>
                <div className="docs-example">
                    <BadgeLinksExample />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{BadgeLinksExampleSource}</PrismCode>
                </pre>
                <h4>Properties</h4>
                <pre>
                    <PrismCode className="language-jsx">
                        {`Badge.propTypes = {
  color: PropTypes.string,
  pill: PropTypes.bool,
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  children: PropTypes.node,
  className: PropTypes.string,
  cssModule: PropTypes.object,
};

Badge.defaultProps = {
  color: 'secondary',
  pill: false,
  tag: 'span',
};`}
                    </PrismCode>
                </pre>
                <h3>Badges with icon</h3>
                <div className="docs-example">
                    <BadgeWithIconsExample />
                </div>
                <pre>
                    <PrismCode className="language-jsx">{BadgeWithIconsExampleSource}</PrismCode>
                </pre>
            </div>);
    }
}
